import CompanyComponentVue from "@/components/master/features/Company/CompanyComponent.vue";
import DatabaseUserComponent from "@/components/master/features/DatabaseUser/DatabaseUserComponent.vue";
import FinancialYearComponentVue from "@/components/master/features/FinancialYear/FinancialYearComponent.vue";
import ForgetPasswordComponent from "@/components/master/features/ForgetPassword/ForgetPasswordComponent.vue";
import LoginComponent from "@/components/master/features/Login/LoginComponent.vue";
import ModuleComponent from "@/components/master/features/Module/ModuleComponent.vue";
import NotFoundComponent from "@/components/master/features/NotFound/NotFoundComponent.vue";
import PageComponent from "@/components/master/features/Page/PageComponent.vue";
import PermissionComponent from "@/components/master/features/Permission/PermissionComponent.vue";
import RecoverPasswordComponentVue from "@/components/master/features/RecoverPassword/RecoverPasswordComponent.vue";
import RegisterComponent from "@/components/master/features/Register/RegisterComponent.vue";
import SubscriptionComponentVue from "@/components/master/features/Subscription/SubscriptionComponent.vue";
import SyncLogComponentVue from "@/components/master/features/SyncLog/SyncLogComponent.vue";
import UserComponent from "@/components/master/features/User/UserComponent.vue";
import { RouteRecordRaw, createRouter, createWebHistory } from "vue-router";
import { authGuard } from "../services/authGuard";
import fortnoxPageRoutes from "./fortnox.routes";
import powerOfficePageRoutes from "./poweroffice.routes";
import resultSheetRoutes from "./resultsheet.routes";
import EntitySetupComponent from "@/components/businesscentral/features/EntitySetup/EntitySetupComponent.vue";
import corePageRoutes from "./core.routes";
import financePageRoutes from "./finance.routes";
import netVisorPageRoutes from "./netvisor.routes";
import AccessDeniedComponent from "@/components/master/features/Access Denied/AccessDeniedComponent.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    redirect: "/home",
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/not-found",
  },
  {
    path: "/not-found",
    name: "Not Found",
    component: NotFoundComponent,
  },
  {
    path: "/access-denied",
    name: "Access Denied",
    component: AccessDeniedComponent,
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/components/master/features/Home/HomeComponent.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/sync-log-summary",
    name: "Sync Log Summary",
    component: () => import("@/components/master/features/SyncLogSummary/SyncLogSummaryComponent.vue"),
    meta: {
      requiresAuth: true,
      titleTrail: ['log', 'syncLogSummary'],
    },
  },
  {
    path: "/subscription",
    name: "Subscription",
    component: SubscriptionComponentVue,
    meta: {
      requiresAuth: true,
      titleTrail: ['settings', 'customer'],
    },
  },
  {
    path: "/user",
    name: "User",
    component: UserComponent,
    meta: {
      requiresAuth: true,
      parentKey: "settings",
      titleKey: "user",
    },
  },
  {
    path: "/permission",
    name: "Permission",
    component: PermissionComponent,
    meta: {
      requiresAuth: true,
      titleTrail: ['settings', 'permission'],
    },
  },
  {
    path: "/module",
    name: "Module",
    component: ModuleComponent,
    meta: {
      requiresAuth: true,
      titleTrail: ['settings', 'module'],
    },
  },
  // {
  //   path: "/register",
  //   name: "Register",
  //   component: RegisterComponent,
  // },
  {
    path: "/login",
    name: "Login",
    component: LoginComponent,
  },
  {
    path: "/forget-password",
    name: "Forget Password",
    component: ForgetPasswordComponent,
  },
  {
    path: "/page",
    name: "Page",
    component: PageComponent,
    meta: {
      requiresAuth: true,
      titleTrail: ['settings', 'page'],
    },
  },
  {
    path: "/recoverPassword",
    name: "RecoverPassword",
    component: RecoverPasswordComponentVue,
    meta: { requiresAuth: false },
  },
  {
    path: "/financialYear",
    name: "Financial Year",
    component: FinancialYearComponentVue,
    meta: {
      requiresAuth: true,
      titleTrail: ['fortnox', 'financialYear'],
    },
  },
  {
    path: "/syncLog",
    name: "Sync Log",
    component: SyncLogComponentVue,
    meta: {
      requiresAuth: true,
      titleTrail: ['log', 'syncLog'],
    },
  },
  {
    path: "/page-build",
    name: "Page Build",
    component: () => import("@/components/pagebuilder/view/PageBuildComponent.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/page-manage",
    name: "Page Manage",
    component: () => import("@/components/pagebuilder/view/PageManageComponent.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/data-sync-configuration",
    name: "Data Sync Configuration",
    component: () => import("@/components/master/features/DataSyncConfiguration/DataSyncConfigurationComponent.vue"),
    meta: {
      requiresAuth: true,
      titleTrail: ['settings', 'dataSyncConfig'],
    },
  },
  {
    path: "/app-log",
    name: "Application Log",
    component: () => import("@/components/master/features/CentralAppLog/CentralAppLogComponent.vue"),
    meta: {
      requiresAuth: true,
      titleTrail: ['settings', 'appLog'],
    },
  },
  {
    path: "/db-user",
    name: "Database User",
    component: DatabaseUserComponent,
    meta: {
      requiresAuth: true,
      titleTrail: ['settings', 'databaseUser'],
    },
  },
  {
    path: "/fortnox-company",
    name: "Fortnox Token Info",
    component: () => import("@/components/master/features/FortnoxTokenInfo/FortnoxTokenInfoComponent.vue"),
    meta: {
      requiresAuth: true,
      titleTrail: ['log', 'fortnoxCompany'],
    },
  },
  {
    path: '/fortnox-error-log',
    name: 'Fortnox Error Log',
    component: () =>
      import(
        '@/components/master/features/FortnoxErrorLog/FortnoxErrorLogComponent.vue'
      ),
    meta: { requiresAuth: true },
  },
  {
    path: '/entity-sync-request',
    name: 'Entity Sync Request',
    component: () =>
      import(
        '@/components/master/features/EntitySyncRequest/EntitySyncRequestComponent.vue'
      ),
    meta: { requiresAuth: true },
  },
  {
    path: '/database-scripts',
    name: 'Database Script Runner',
    component: () =>
      import(
        '@/components/master/features/DatabaseScript/DatabaseScriptRunner.vue'
      ),
    meta: {
      requiresAuth: true,
      titleTrail: ['settings', 'databaseScripts'],
    },
  },
  ...financePageRoutes,
  ...resultSheetRoutes,
  ...fortnoxPageRoutes,
  ...powerOfficePageRoutes,
  ...corePageRoutes,
  ...netVisorPageRoutes,
  // business cnetral route
  {
    path: "/bs/entitySetup",
    name: "Entity Setup",
    component: () => import("@/components/businesscentral/features/EntitySetup/EntitySetupComponent.vue"),
    meta: {
      requiresAuth: true,
      titleTrail: ['businessCentral', 'entitySetup'],
    },
  },
  {
    path: "/bs/apiConfig",
    name: "API Configuration",
    component: () => import("@/components/businesscentral/features/APIConfig/APIConfigComponent.vue"),
    meta: {
      requiresAuth: true,
      titleTrail: ['businessCentral', 'configuration', 'apiConfig'],
    },
  },
  {
    path: "/bs/oneLakeConfig",
    name: "OneLake Configuration",
    component: () => import("@/components/businesscentral/features/OnelakeConfig/OnelakeConfigComponent.vue"),
    meta: {
      requiresAuth: true,
      titleTrail: ['businessCentral', 'configuration', 'oneLakeConfig'],
    },
  },
  {
    path: "/bs/storageConfig",
    name: "Storage Configuration",
    component: () => import("@/components/businesscentral/features/StorageConfig/StorageConfigComponent.vue"),
    meta: {
      requiresAuth: true,
      titleTrail: ['businessCentral', 'configuration', 'storageConfig'],
    },
  },
  {
    path: "/bs/company",
    name: "Business Central Company",
    component: () => import("@/components/businesscentral/features/Company/CompanyComponent.vue"),
    meta: {
      requiresAuth: true,
      titleTrail: ['businessCentral', 'company'],
    },
  },
  {
    path: "/bs/company/synclogs",
    name: "Business Central Sync Logs",
    component: () => import("@/components/businesscentral/features/Company/BcSyncLogsComponent.vue"),
    meta: {
      requiresAuth: true,
      titleTrail: ["businessCentral", "company", "syncLogs"],
    },
  },
  {
    path: "/bs/entity",
    name: "Business Central Entity",
    component: () => import("@/components/businesscentral/features/Entity/EntityComponent.vue"),
    meta: {
      requiresAuth: true,
      titleTrail: ['businessCentral', 'entity'],
    },
  },
  {
    path: "/bs/Environment",
    name: "Business Central Environment",
    component: () => import("@/components/businesscentral/features/Environmentinfo/EnvironmentInfoComponent.vue"),
    meta: {
      requiresAuth: true,
      titleTrail: ['businessCentral', 'environment'],
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    authGuard(to, from, next);
  } else {
    next();
  }
});

export default router;
